import React, { PureComponent } from 'react'
//import Button from "@material-ui/core/Button";
import PropTypes from 'prop-types';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from "@material-ui/core/Checkbox";
import tagsConfigHelper from '../../../helpers/tagsConfigHelper'
import ControlManager from '../ControlManager'
//import { OverlayTrigger,Tooltip,Popover } from '../../../assets/javascripts/bootstrap/popover'
//import './App.css';

//import { OverlayTrigger, Popover } from 'react-bootstrap';
//import 'bootstrap/dist/css/bootstrap.min.css';

class Information extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
          width:350,
          left:0,
          bottom:0
        }

    }
 
    componentWillReceiveProps(nextProps) {
      if (nextProps.width !== this.state.width) {
          this.setState({width: nextProps.width})
      }
      if (nextProps.left !== this.state.left) {
        this.setState({left: nextProps.left})
      }
      if (nextProps.bottom !== this.state.bottom) {
          this.setState({bottom: nextProps.bottom})
      }
    }

    render() {

      // const popover = (
      //   <Popover id="popover-basic" >
      //     <Popover.Header as="h3">{this.props.head}</Popover.Header>
      //     <Popover.Body>
      //       {this.props.children}
      //     </Popover.Body>
      //   </Popover>
      // );
      
        return (
            <>
                {/* <OverlayTrigger 
         trigger="hover" 
         placement="right" 
         overlay={popover}
         >
        <img variant="success" className="icon-info2" scr="..assets/images/icons/iconinfo.png"/>
      </OverlayTrigger> */}
        <div class="tooltipInformation" > 
        <img variant="success"  className="icon-info2" scr="..assets/images/icons/icon-info.svg"/>
          <span class="tooltiptext" style={{fontSize:'18px',width:this.state.width,left:this.state.left,bottom:this.state.bottom}} >
            {this.props.children}
          </span>
        </div>
          </>
        )
    }
}


export default Information

